import { AppDispatch } from '@/domain/store';

import { getImpactCalculateTourForProject } from '../get-impact-calculate-tour-for-project.action';

const DELAY_FOR_SECOND_CALL = 2000;

export function dispatchTwiceGetImpactCalculateTour(
  dispatch: AppDispatch,
  projectId: number,
) {
  dispatch(getImpactCalculateTourForProject({ projectId }));
  setTimeout(
    () => dispatch(getImpactCalculateTourForProject({ projectId })),
    DELAY_FOR_SECOND_CALL,
  );
}
